import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';
import { makeAutoObservable } from 'mobx';
import { bpHistory } from 'global/bpHistory';
import { RouteV2Id } from 'routes/routesConfigV2';
import EnrollmentPeriodModule from 'store/modules/enrollment/enrollmentPeriodModule';
import GroupModule from 'store/modules/group/groupModule';
import { InviteEmployersDelegate } from 'store/modules/group/ui-stores/inviteEmployersDelegate';
import { ChecklistCompletionStatus } from '@insurancemenu/imenu-components-lib/dist/types';

interface SidebarChecklistStep {
  label: string;
  completionStatus: ChecklistCompletionStatus;
  onClick: () => void;
  pageId: RouteV2Id;
}

export class SidebarDelegate {
  private _groupModule: GroupModule;
  private _enrollmentPeriodModule: EnrollmentPeriodModule;
  public inviteEmployersDelegate: InviteEmployersDelegate;

  public get groupId(): string {
    return this._groupModule.group.id;
  }

  public get checklistSteps(): SidebarChecklistStep[] {
    return (this._enrollmentPeriodModule.checklist || { checklistOptions: [] }).checklistOptions.map((option) => ({
      /** TO_DO: Remove dependency from CARD_DATA to routeConfigV2 */
      label: CARD_DATA[option.card]?.title,
      completionStatus: option.completionStatus,
      onClick: (): void => {
        const redirectUrl = CARD_DATA[option.card]?.redirectTo?.(
          this._enrollmentPeriodModule.enrollmentPeriod?.id,
          this._groupModule.group?.id,
        );
        if (redirectUrl) {
          bpHistory.push(redirectUrl);
        }
      },
      /** TO_DO: Remove dependency from CARD_DATA to routeConfigV2 */
      pageId: option.card as unknown as RouteV2Id,
    }));
  }

  public get isFlowDataLoading(): boolean {
    return this._groupModule.isLoading || this._enrollmentPeriodModule.isLoading;
  }

  constructor(groupModule: GroupModule, enrollmentPeriodModule: EnrollmentPeriodModule) {
    this._groupModule = groupModule;
    this._enrollmentPeriodModule = enrollmentPeriodModule;
    this.inviteEmployersDelegate = new InviteEmployersDelegate({ groupModule });

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
